import React from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, TouchableOpacity } from 'react-native';

import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';

const RadioButton = ({
    disabled,
    isSelected,
    toggleSelection,
    inactiveStyle,
    innerInactiveStyle,
    innerActiveStyle,
    outerContainer,
    outerActiveContainer
}) => (
        <TouchableOpacity
            disabled={disabled}
            onPress={toggleSelection}
            style={[
                styles.outerContainer,
                outerContainer,
                inactiveStyle,
                disabled && styles.disabled,
                isSelected && { backgroundColor: Theme.PRIMARY },
                (isSelected && disabled) && styles.selectedDisabled,
                isSelected && outerActiveContainer
            ]}>
            <View
                style={[
                    styles.innerContainer,
                    disabled && styles.disabled,
                    innerInactiveStyle,
                    isSelected && { ...styles.innerActiveContainer, ...innerActiveStyle },
                ]}
            />
        </TouchableOpacity>
    );

RadioButton.propTypes = {
    disabled: PropTypes.bool,
    isSelected: PropTypes.bool.isRequired,
    toggleSelection: PropTypes.func.isRequired
};

const styles = StyleSheet.create({
    outerContainer: {
        height: defaultScale(20),
        width: defaultScale(20),
        borderRadius: defaultScale(20 / 2),
        alignItems: 'center',
        justifyContent: 'center',
    },
    selectedDisabled: {
        backgroundColor: Theme.GREY_DARK_MEDIUM,
    },
    innerContainer: {
        width: defaultScale(10),
        height: defaultScale(10),
        borderRadius: defaultScale(10 / 2),
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: Theme.GREY_LIGHT,
    },
    innerActiveContainer: {
        backgroundColor: Theme.WHITE,
    },
    disabled: {
        backgroundColor: Theme.GREY,
    }
});

export default RadioButton;
